import React from 'react';
import { Row, Col, Divider, Typography, Space } from 'antd';

const { Title, Text } = Typography;

const IndividualRelTypeCount = ({ relationshipsByType }) => {
    if (!relationshipsByType) return null;

    const entries = Object.entries(relationshipsByType);
    const total = entries.reduce((acc, [, count]) => acc + count, 0);

    return (
        <Space direction="vertical" size="large" style={{ width: '100%', rowGap: 0 }}>
            <Row gutter={[8, 0]} align="middle" justify="space-between" wrap={false}>
                {/* Título a la izquierda */}
                <Col xs={24} md={24} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Title level={5} style={{ color: '#339C98', margin: 0 }}>
                        ¿Quién participó?
                    </Title>
                </Col>
            </Row>
            <Row gutter={[8, 0]} align="middle" justify="space-between" wrap={false}>
                {/* Tipos de relación */}
                <Col xs={24} md={20} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Row gutter={[8, 0]} justify="start" align="middle" wrap={false}>
                        {entries.map(([label, count], index) => (
                            <React.Fragment key={label}>
                                <Col style={{ textAlign: 'center' }}>
                                    <Text style={{ fontSize: 10, color: '#339C98' }}>{label}</Text>
                                    <br />
                                    <Text strong style={{ fontSize: 24 }}>{count}</Text>
                                </Col>
                                {index < entries.length - 1 && (
                                    <Divider type="vertical" style={{ height: 40, margin: '0 16px', borderColor: '#dce3e8' }} />
                                )}
                            </React.Fragment>
                        ))}
                    </Row>
                </Col>

                {/* Total */}
                <Col xs={24} md={4} style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center'                    
                }}>
                    <div style={{
                        backgroundColor: '#3E246B',
                        borderRadius: 12,
                        width: 70,
                        height: 70,
                        textAlign: 'center',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <span strong style={{ color: 'white', fontSize: 24, fontWeight: 500}}>{total}</span>
                        <span style={{ color: 'white' }}>Total</span>
                    </div>
                </Col>
            </Row>
        </Space>
    );
};

export default IndividualRelTypeCount;
